import React  from 'react';
import ServiceSearch from './ServiceSearch';
import CreateNewService from './CreateNewService';
import ServiceStatusFilter from './ServiceStatusFilter';
//import ErrorHandlingStatusFilter from './ErrorHandlingFilter/ErrorHandlingStatusFilter';
import styles from './ServiceFilters.module.less';

type ProxyServiceSettingsFiltersProps = {
  setParams: (name: string, value: string) => void;
  requestParams: any;
  setRequestParams: any;
};

const ProxyServiceSettingsFilters: React.FC<ProxyServiceSettingsFiltersProps> = ({ setParams, requestParams, setRequestParams}) => {
  const onChangeSearch = (value: string): void => {
    setParams('proxyServiceName', value);
  };
  const onChangeStatusFilter = (value: string): void => {
    setParams('enabled', value);
    
  };
  
  // const onChangeErrorHandlingFilter = (value: string): void => {
  //   setParams('ipErrorHandle', value);
  // };
  
  return (
    <div className={styles.filterPanelWrapper}>
      <div className={styles.createNewAnonProxy}>
        <CreateNewService requestParams={requestParams} setRequestParams={setRequestParams} />
      </div>
      <div className={styles.anonProxySearch}>
        <ServiceSearch onChangeSearch={onChangeSearch} value={''} />
      </div>
      <div className={styles.filterPanelSchema}>
        <ServiceStatusFilter onStatusUpdate={onChangeStatusFilter} />
      </div>
      {/* <div className={styles.filterPanelSchema}>
        <ErrorHandlingStatusFilter onErrorHandlingUpdate={onChangeErrorHandlingFilter}/>
      </div> */}
    </div>
  );
};

export default ProxyServiceSettingsFilters;
